// @generated by rtk-query-codegen -- DO NOT EDIT
import { baseApi as api } from "../client/baseApi";
import type { QuotaLevel, QuotaLine } from "../quota/domain.generated";
import type { Blocking, LineUsage, Mode, OrgUsageResponse, WorkspaceUsage } from "../quota/dto.generated";
export const addTagTypes = ["quota"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getApiWorkspacesByIdQuota: build.query<
        GetApiWorkspacesByIdQuotaApiResponse,
        GetApiWorkspacesByIdQuotaApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/quota`,
        }),
        providesTags: ["quota"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as quotaApi };
export type GetApiWorkspacesByIdQuotaApiResponse =
  /** status 200 OK */ { data: QuotaOrgUsageResponse };
export type GetApiWorkspacesByIdQuotaApiArg = {
  /** Workspace ID */
  id: string;
};
export type QuotaBlocking = Blocking;
export type DomainQuotaLevel = QuotaLevel;
export type DomainQuotaLine = QuotaLine;
export type QuotaMode = Mode;
export type QuotaWorkspaceUsage = WorkspaceUsage;
export type QuotaLineUsage = LineUsage;
export type QuotaOrgUsageResponse = OrgUsageResponse;
export const {
  useGetApiWorkspacesByIdQuotaQuery,
  useLazyGetApiWorkspacesByIdQuotaQuery,
} = injectedRtkApi;
